import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DataListTag, DataListTagGroup } from "../../models/data-list";

@Component({
    selector: "app-tag-picker-tabs",
    templateUrl: "./tag-picker-tabs.component.html",
    styleUrls: ["./tag-picker-tabs.component.scss"],
    standalone: false
})
export class TagPickerTabsComponent implements OnInit {
  @Input("available-tags") availableTagGroups: DataListTagGroup[] = [];
  @Input("preselected-tag-ids") preselectedTagIds: string[] = [];
  @Output() selectedTagCountChanged = new EventEmitter<number>();

  selectedTags: DataListTag[][];

  constructor() {}

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.selectedTags = new Array(this.availableTagGroups.length);

    let index = 0;
    this.availableTagGroups.forEach(
      (g) =>
        (this.selectedTags[index] = g.tags.filter((t) =>
          this.preselectedTagIds.includes(t.id)
        )),
      index++
    );
  }

  public getSelectedCount(index: number) {
    const count = this.selectedTags[index]?.length;
    return count == 0 ? "" : count;
  }

  public getSelectedTagIds() {
    const selected: DataListTag[] = [];
    this.selectedTags.forEach((r) => r.forEach((c) => selected.push(c)));
    return selected.map((m) => m.id);
  }

  tagChanged() {
    const selectedCount = this.selectedTags.reduce(
      (count, row) => count + row.length,
      0
    );
    this.selectedTagCountChanged.emit(selectedCount);
  }

  clearAll() {
    this.load();
  }
}
